import { render } from "./ScrollToTopBtn.vue?vue&type=template&id=6f6f7681&scoped=true"
import script from "./ScrollToTopBtn.vue?vue&type=script&lang=js"
export * from "./ScrollToTopBtn.vue?vue&type=script&lang=js"

import "./ScrollToTopBtn.vue?vue&type=style&index=0&id=6f6f7681&scoped=true&lang=scss"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6f7681"]])

export default __exports__